import { render, staticRenderFns } from "./ModalPasswords.vue?vue&type=template&id=50d8eebe&scoped=true&lang=pug&"
import script from "./ModalPasswords.vue?vue&type=script&lang=js&"
export * from "./ModalPasswords.vue?vue&type=script&lang=js&"
import style0 from "./ModalPasswords.vue?vue&type=style&index=0&id=50d8eebe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d8eebe",
  null
  
)

export default component.exports